import { LoginForm } from "@/components/auth/login-form";

export function LoginPage() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-slate-100">
			<div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
				<div className="mb-6 text-center">
					<h1 className="text-xl font-bold text-slate-900">Efes Checkup</h1>
					<p className="mt-1 text-sm text-slate-500">Войдите в систему</p>
				</div>
				<div className="flex justify-center">
					<LoginForm />
				</div>
			</div>
		</div>
	);
}
